<template>
  <div class="agree-more">
    <section class="top-fixing">
      <section class="common-sub-top container">
        <section class="top-info-wrap">
          <!-- 뒤로가가-->
          <div class="prev-wrap">
            <a @click="pageBefore()" class="prev"></a>
            <span class="name-wrap">
              <span class="name">{{ ptntNm }}</span
              ><strong>님</strong>의 환자동의서
            </span>
          </div>
          <!-- //뒤로가가-->

          <!-- 선택-->
          <div class="select-wrap">
            <div class="select" @click="checkboxCancel()" id="deleteCheckFlag">선택</div>
          </div>
          <!-- //선택-->
        </section>

        <!-- 동의서 소팅-->
        <section class="agree-search-wrap">
          <div class="select">
            <div class="select-type agreeSearch_open" @click="clickDisabled">
              {{ selectDocNm }}
            </div>
          </div>
          <div class="date-range">
            <div class="select-type range_open" @click="clickDisabled">{{ selectYYYYNm }}</div>
          </div>
        </section>
        <!-- //동의서 소팅-->
      </section>
    </section>

    <!-- 간격 조정용 -->
    <div class="space-agree"></div>
    <!-- //간격 조정용 -->

    <!-- 동의서 리스트-->
    <section v-if="items.length === 0" class="patient-none">
      <img src="../../assets/img/common/img-none2.png" alt="동의서" />
      <span class="nodata">동의서가 없습니다</span>
    </section>
    <section class="agree-list container-fix">
      <ul>
        <template v-if="items.length > 0">
          <li v-for="(item, idx) in items" :key="idx" @click="clickDocumentDetail(item.documentCd, item.documentNm, item.receptNo, item.seqNo)">
            <div class="agree-wrap" :id="`C${item.receptNo + item.seqNo}`">
              <div class="img">
                <img v-bind:src="`data:image/gif;base64,${item.thumbnail}`" alt="동의서" />
              </div>

              <div class="ckbox">
                <input
                  name="checkbox"
                  type="checkbox"
                  :id="item.receptNo + item.seqNo"
                  :value="{ receptNo: item.receptNo, seqNo: item.seqNo }"
                  :data-recept-no="item.receptNo"
                  :data-seq-no="item.seqNo"
                  v-model="checkedNames"
                />
              </div>
            </div>

            <div class="subject">
              {{ item.documentNm }}
            </div>

            <div class="date">{{ `${item.entYmd.substr(0, 4)}년 ${item.entYmd.substr(4, 2)}월 ${item.entYmd.substr(6, 2)}일 ${item.entTime.substr(0, 2)}시 ${item.entTime.substr(2, 2)}분` }}</div>
          </li>
        </template>

        <li></li>
        <infinite-loading :identifier="infiniteId" @infinite="infiniteHandler">
          <div slot="no-more">
            <div class="test"></div>
          </div>
          <div slot="no-results"></div>
          <div slot="spinner" class="pos"></div>
        </infinite-loading>
      </ul>

      <section class="view-quick-menu">
        <button @click="openPenChartMenu">
          <img :src="require('@/assets/img/common/quick-menu.png')" alt="" />
        </button>
      </section>

      <!-- 작성 영역-->
      <section class="write-wrap agree-writ" id="agreePopupType">
        <a @click="agreePopupType()"><i></i><span>신규 동의서 작성하기</span></a>
      </section>
      <!-- //작성 영역-->

      <!-- 삭제 영억-->
      <section class="del-wrap">
        <a class="del_open">
          <i></i>삭제 <span class="num">{{ checkedNames.length }}</span>
        </a>
      </section>
      <!-- //삭제 영억-->
    </section>

    <!-- 조회 동의서 작성 모달-->
    <section class="agree-modal" id="agreeSearch">
      <h1>신규 동의서 양식 선택</h1>
      <div id="id_agreeSearch_close" class="close agreeSearch_close">닫기</div>
      <ul>
        <li><a @click="changeType('', '')">동의서 양식 전체</a></li>
        <li v-for="(item, idx) in optionDoc" :key="idx">
          <a @click="changeType(item.documentCd, item.documentNm)">
            <template v-if="item.documentNm.length > 20"> {{ item.documentNm.substr(0, 20) }}... </template>
            <template v-else>
              {{ item.documentNm }}
            </template>
          </a>
        </li>
      </ul>
    </section>
    <!-- //조회 동의서 작성 모달-->

    <!-- 기간선택 모달-->
    <section class="agree-modal" id="range">
      <h1>조회 기간 선택</h1>
      <div id="id_range_close" class="close range_close">닫기</div>
      <ul>
        <li><a @click="changeTypeDate('')">기간 전체</a></li>
        <li v-for="year in years" :key="year">
          <a @click="changeTypeDate(`${year}`)">{{ year }}년</a>
        </li>
      </ul>
    </section>
    <!-- //기간선택 모달-->

    <!-- 신규 동의서 작성 모달-->
    <section class="agree-modal" id="agree">
      <h1>신규 동의서 양식 선택</h1>
      <div class="close agree_close">닫기</div>
      <ul>
        <li v-for="(item, idx) in optionDoc" :key="idx">
          <a @click="callDocument(`${item.documentCd}`, `${item.documentNm}`)">
            <template v-if="item.documentNm.length > 20"> {{ item.documentNm.substr(0, 20) }}... </template>
            <template v-else>
              {{ item.documentNm }}
            </template>
          </a>
        </li>
      </ul>
    </section>
    <!-- //신규 동의서 작성 모달-->

    <!-- 삭제모달-->
    <section class="del-modal" id="del">
      <div class="alert">선택한 환자동의서를<br />정말 삭제하시겠습니까?</div>
      <div class="btn-group">
        <a href="javascript:;" class="btn-cancel del_close">취소</a>
        <a @click="deleteDoc()" class="btn-del">삭제</a>
      </div>
    </section>
    <JqueryCommon />
    <JqueryPopup />
    <ModalOK :propData="modalData" :okFunctionCustom="modalFunction" />
    <!-- 환자 클릭시 메뉴 정보 모달 -->
    <PenChartMenu :selectedInfo="$route.params.selectedInfo" />
  </div>
</template>
<script src="https://ajax.googleapis.com/ajax/libs/jquery/3.2.1/jquery.min.js"></script>
<script src="https://code.jquery.com/ui/1.12.1/jquery-ui.js"></script>
<script>
import JqueryCommon from '../../components/jquery/JqueryCommon';
import JqueryPopup from '../../components/jquery/JqueryPopup';
import InfiniteLoading from 'vue-infinite-loading';
import PenChartMenu from '@/components/popup/PenChartMenu';
import { popOpenAndScrollNone } from '@/utils/UtilPopup';
import ModalOK from '@/components/modal/ModalOK';

export default {
  components: {
    JqueryCommon,
    JqueryPopup,
    InfiniteLoading,
    PenChartMenu,
    ModalOK
  },
  computed: {
    years() {
      const year = new Date().getFullYear();
      return Array.from({ length: year - 2019 }, (value, index) => year - index);
    }
  },
  data: () => ({
    modalData: {
      id: 'reserveModal',
      msg: ''
    },
    modalFunction: Function,
    selectDoc: '',
    selectDocNm: '동의서 양식 전체',
    selectYYYY: '',
    selectYYYYNm: '기간 전체',
    selectDate: '',
    activeTab: '',
    selectDept: '',
    receptNo: '',
    ptntNm: '',
    ptntNo: '',
    optionDoc: [
      {
        documentCd: '',
        documentNm: ''
      }
    ],
    items: [],
    page: 1,
    infiniteId: +new Date(),
    checkedNames: [],
    deleteJson: [{ receptNo: '', seqNo: '' }],
    checkFlag: 'N',
    url: '',
    selectPossibleName: '선택'
  }),
  mounted() {
    clearInterval(this.$store.state.timerId);
    this.receptNo = this.$store.state.searchInfo.receptNo;
    this.ptntNo = this.$store.state.searchInfo.ptntNo;
    this.ptntNm = this.$store.state.searchInfo.ptntNm;

    window.receiveAgreeList = this.receiveAgreeList;

    if ($('#agreeSearch_wrapper').length > 0) $('#agreeSearch_wrapper').remove();
    if ($('#agree_wrapper').length > 0) $('#agree_wrapper').remove();
    if ($('#del_wrapper').length > 0) $('#del_wrapper').remove();
    if ($('#range_wrapper').length > 0) $('#range_wrapper').remove();

    if ($('#agree-modal_wrapper').length > 0) $('#agree-modal_wrapper').remove();

    $('#deleteCheckFlag').click(() => {
      if (this.checkFlag == 'Y') {
        this.checkFlag = 'N';
        // this.selectPossibleName = '선택';
      } else {
        this.checkFlag = 'Y';
        // this.selectPossibleName = '취소';
      }
    });

    //모달
    $('#agree').popup({
      // beforeopen: function () {
      //   alert("0");
      //   return false;
      // },
      // onopen: function () {
      //   alert("1");
      //   return false;
      // },
      transition: 'all 0.3s',
      blur: true,
      escape: true,
      scrolllock: true,
      closebutton: false,
      background: true
    });

    $('#agreeSearch').popup({
      transition: 'all 0.3s',
      blur: true,
      escape: true,
      scrolllock: true,
      closebutton: false,
      background: true
    });

    $('#del').popup({
      transition: 'all 0.3s',
      blur: true,
      escape: true,
      scrolllock: true,
      closebutton: false,
      background: true,
      onclose: function () {
        document.body.style.overflow = 'visible';
      }
    });

    $('#range').popup({
      transition: 'all 0.3s',
      blur: true,
      escape: true,
      scrolllock: true,
      closebutton: false,
      background: true
    });

    //동의서 목록
    try {
      let url = `/agree/documents?receptNo=${this.receptNo}&sortNm=${this.$store.state.settingInfo.sortNm}&sortGb=${this.$store.state.settingInfo.sortGb}`;
      if (this.$osType === 'web' || this.$osType === 'ios') {
        this.$axios
          .get(url)
          .then((res) => {
            this.optionDoc = res.data.data;
          })
          .catch((e) => {
            console.log(e);
          });
      } else {
        let result = this.$util.getApi(`${this.$store.state.apiDomain}${url}`);
        this.optionDoc = result.data;
      }
    } catch (e) {}

    if (this.$store.state.searchInfo.selectDoc != null) {
      this.selectDoc = this.$store.state.searchInfo.selectDoc;
    } else {
      this.selectDoc = '';
    }

    if (this.$store.state.searchInfo.selectDocNm != null) {
      this.selectDocNm = this.$store.state.searchInfo.selectDocNm;
    } else {
      this.selectDocNm = '동의서 양식 전체';
    }

    if (this.$store.state.searchInfo.selectYYYY != null) {
      this.selectYYYY = this.$store.state.searchInfo.selectYYYY;
    } else {
      this.selectYYYY = '';
    }

    if (this.$store.state.searchInfo.selectYYYYNm != null) {
      this.selectYYYYNm = this.$store.state.searchInfo.selectYYYYNm;
    } else {
      this.selectYYYYNm = '기간 전체';
    }

    //infiniteHandler 초기 한번 호출 시켜줘야됨. 가로모드일 경우 infiniteHandler 메소드가 호출 안될 때가 있음..
    if (window.matchMedia('(orientation: portrait)').matches) {
      //세로모드
      // Portrait 모드일 때 실행할 스크립트
      // 폭과 높이가 같으면 Portrait 모드로 인식돼요
    } else {
      //가로모드
      // Landscape 모드일 때 실행할 스크립트
      try {
        this.infiniteHandler();
        //this.$refs.InfiniteLoadingRef.stateChanger.reset();
      } catch (e) {}
    }
  },
  methods: {
    callDocument(documentCd, documentNm) {
      $('.agree_close').click();
      //제대로 파라미터 안넘기면 펜차트 종료됨.
      let json = `{"documentCd":"${documentCd}","documentNm":"${documentNm}","receptNo":"${this.receptNo}","entEmpl":"1","ptntNo":"${this.ptntNo}","pageNo":"${this.page}","yyyyDate":"${this.selectYYYY}"}`;
      try {
        var varUA = navigator.userAgent.toLowerCase(); //userAgent 값 얻기
        if (varUA.match('android') != null) {
          window.penchart.callDocument(json);
        } else if (varUA.indexOf('iphone') > -1 || varUA.indexOf('ipad') > -1 || varUA.indexOf('ipod') > -1) {
          //IOS 일때 처리
          window.webkit.messageHandlers.callDocument.postMessage(json);
        }
      } catch (e) {}
    },

    changeType(documentCd, documentNm) {
      $('#id_agreeSearch_close').click();
      if (documentCd == '') {
        (this.selectDoc = ''), (this.selectDocNm = '동의서 양식 전체');
      } else {
        this.selectDoc = documentCd;
        this.selectDocNm = documentNm;
      }

      this.page = 1;
      this.items = [];
      this.infiniteId += 1;
    },

    changeTypeDate(selectYYYY) {
      $('#id_range_close').click();
      this.selectYYYY = selectYYYY;
      if (selectYYYY == '') {
        this.selectYYYYNm = '기간 전체';
      } else {
        this.selectYYYYNm = selectYYYY;
      }

      this.page = 1;
      this.items = [];
      this.infiniteId += 1;
    },
    //모바일 페이징 처리
    async infiniteHandler($state) {
      let url = `/agree/list/${this.ptntNo}/${this.page}?pageSize=15&docuemntCd=${this.selectDoc}&yyyyDate=${this.selectYYYY}`;
      this.url = url;
      let result = null;
      try {
        if (this.$osType === 'web' || this.$osType === 'ios') {
          await this.$axios.get(url).then((response) => {
            result = response.data;
          });
        } else {
          result = this.$util.getApi(`${this.$store.state.apiDomain}${url}`);
        }

        //API 결과 공통 처리
        if (result.state == 'failed') {
          $state.complete();
        } else {
          if (result.data.list.length) {
            this.page += 1;
            this.items.push(...result.data.list);
            if (this.page > result.data.maxPage) {
              $state.complete();
            } else {
              $state.loaded();
            }
          } else {
            $state.loaded();
          }
        }
      } catch (e) {}

      if (this.checkFlag == 'Y') {
        $('.agree-list .ckbox').css('display', 'block');
      }
    },
    pageBefore() {
      this.$router
        .push({
          name: '대기리스트',
          params: {
            selectDept: this.$route.params.selectDept,
            activeTab: this.$route.params.activeTab,
            searchKeyword: this.$route.params.searchKeyword,
            selectYYYY: this.$route.params.selectYYYY,
            selectDate: this.$route.params.selectDate,
            selectDept: this.$route.params.selectDept,
            activeTab: this.$route.params.activeTab
          }
        })
        .catch((e) => {
          console.log('catch router ServiceSupportMy dupi');
        });
    },
    deleteDoc() {
      $('.btn-cancel').click();
      let url = `/agree`;
      this.deleteJson.splice(0, this.deleteJson.length);

      this.checkedNames.forEach((e) => {
        this.deleteJson.push({
          receptNo: e.receptNo,
          seqNo: e.seqNo
        });
      });
      $('.common-sub-top .select-wrap .select').click();

      if (this.$osType === 'web' || this.$osType === 'ios') {
        this.$axios
          .delete(url, {
            data: { data: this.deleteJson }
          })
          .then(() => {
            this.changeType(this.selectDoc, this.selectDocNm);
            this.checkedNames.splice(0, this.checkedNames.length);
          })
          .catch((error) => {
            console.log(error);
          });
      } else {
        let apiDeleteData = JSON.stringify({
          url: `${this.$store.state.apiDomain}${url}`,
          param: {
            data: this.deleteJson
          }
        });
        let result = this.$util.deleteApi(apiDeleteData);
        this.changeType(this.selectDoc, this.selectDocNm);
        this.checkedNames.splice(0, this.checkedNames.length);
      }
    },
    clickDocumentDetail(documentCd, documentNm, receptNo, seqNo) {
      let id = receptNo + seqNo;
      if (this.checkFlag == 'Y') {
        const temp = document.querySelector(`#C${id}`);
        const tempChk = temp.querySelector('.ckbox input[type="checkbox"]');

        if (temp.classList.contains('selected')) {
          temp.classList.remove('selected');
          tempChk.checked = false;
        } else {
          temp.classList.add('selected');
          tempChk.checked = true;
        }

        const chkDom = document.querySelectorAll('li input[type="checkbox"]');

        this.checkedNames = [];
        chkDom.forEach((e) => {
          if (e.checked) {
            this.checkedNames.push({
              receptNo: e.dataset.receptNo,
              seqNo: e.dataset.seqNo
            });
          }
        });

        return;
      }

      this.$store.state.searchInfo.selectDoc = this.selectDoc;
      this.$store.state.searchInfo.selectDocNm = this.selectDocNm;
      this.$store.state.searchInfo.selectYYYY = this.selectYYYY;
      this.$store.state.searchInfo.selectYYYYNm = this.selectYYYYNm;
      this.$store.state.searchInfo.ptntNm = this.ptntNm;
      this.$store.state.searchInfo.ptntNo = this.ptntNo;

      this.$router.push({
        name: '환자동의서상세',
        params: {
          documentCd: documentCd,
          documentNm: documentNm,
          receptNo: receptNo,
          seqNo: seqNo,
          selectedInfo: this.$route.params.selectedInfo
        }
      });
    },

    //페이지 새로고침
    //documentCd - 동의서 문서 코드
    //ptntNo     - 챠트 번호
    //pageNo     - 페이징 페이지 번호
    //yyyyDate   - 조회 년도
    async receiveAgreeList(documentCd, ptntNo, pageNo, yyyyDate) {
      this.page = 1;
      this.items = [];

      if (window.matchMedia('(orientation: portrait)').matches) {
        //세로모드
        // Portrait 모드일 때 실행할 스크립트
        // 폭과 높이가 같으면 Portrait 모드로 인식돼요
        this.infiniteId += 1;
      } else {
        //가로모드
        // Landscape 모드일 때 실행할 스크립트
        try {
          this.infiniteHandler();
          //this.$refs.InfiniteLoadingRef.stateChanger.reset();
        } catch (e) {}
      }
    },

    checkboxCancel() {
      this.checkedNames.forEach((e) => {
        let id = e.receptNo + e.seqNo;
        const temp = document.querySelector(`#C${id}`);
        temp.classList.remove('selected');
      });

      this.checkedNames.splice(0, this.checkedNames.length);
    },
    agreePopupType() {
      if (this.$route.params.selectedInfo.procNm === '예약' || this.$route.params.selectedInfo.procNm === '접수취소') {
        this.modalFunction = this.modalOKFunction;
        if (this.$route.params.selectedInfo.procNm === '예약') {
          this.modalData.msg = '예약 환자는 작성할 수 없습니다.';
        } else {
          this.modalData.msg = '취소 환자는 작성할 수 없습니다.';
        }

        popOpenAndScrollNone(`#${this.modalData.id} .dim-popup-mark`, `#${this.modalData.id} .dim-popup-content`);
        return;
      }
      //동의서 목록 중 비급여 동의서가 추가 될수 있기 때문에 실시간으로 데이터 다시 한번 가져와서 갱신.
      let url = `/agree/documents?receptNo=${this.receptNo}&sortNm=${this.$store.state.settingInfo.sortNm}&sortGb=${this.$store.state.settingInfo.sortGb}`;
      this.$axios
        .get(url)
        .then((res) => {
          this.optionDoc = res.data.data;
        })
        .catch((e) => {
          console.log(e);
        });

      if (this.selectDoc == '') {
        $('#agreePopupType').addClass('agree_open');
        $('.agree_open').click();
      } else {
        $('#agreePopupType').removeClass('agree_open');
        this.callDocument(this.selectDoc, this.selectDocNm);
      }
    },
    openPenChartMenu() {
      // 팝업 띄우기
      popOpenAndScrollNone('#dimPenChartMenu .dim-popup-mark', '#dimPenChartMenu .dim-popup-content');
    },
    clickDisabled(e) {
      // 삭제 상태일 때 동의서 팝업 안돼!
      if (this.checkFlag === 'Y') {
        e.stopPropagation();
      }
    }
  }
};
</script>

<style scoped src="../../assets/css/page/patientAgreeList.css"></style>
